"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx17 = _interopRequireDefault(require("clsx"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _withMaterial = require("common-components/dist/common/components/Template/withMaterial");
var _context26 = _interopRequireDefault(require("common-components/dist/common/components/Post/context"));
var _context27 = _interopRequireDefault(require("common-components/dist/common/components/App/context"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var _Menu = _interopRequireDefault(require("common-components/dist/common/components/Menu"));
var _LinearProgress = _interopRequireDefault(require("@mui/material/LinearProgress"));
var _Brush = _interopRequireDefault(require("@mui/icons-material/Brush"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _PlayArrow = _interopRequireDefault(require("@mui/icons-material/PlayArrow"));
var _Pause = _interopRequireDefault(require("@mui/icons-material/Pause"));
var _SkipPrevious = _interopRequireDefault(require("@mui/icons-material/SkipPrevious"));
var _SkipNext = _interopRequireDefault(require("@mui/icons-material/SkipNext"));
var _Window = _interopRequireDefault(require("@mui/icons-material/Window"));
var _DesignServices = _interopRequireDefault(require("@mui/icons-material/DesignServices"));
var _Architecture = _interopRequireDefault(require("@mui/icons-material/Architecture"));
var _Save = _interopRequireDefault(require("@mui/icons-material/Save"));
var _Fullscreen = _interopRequireDefault(require("@mui/icons-material/Fullscreen"));
var _Videocam = _interopRequireDefault(require("@mui/icons-material/Videocam"));
var _ViewInAr = _interopRequireDefault(require("@mui/icons-material/ViewInAr"));
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _ToggleButton = _interopRequireDefault(require("@mui/material/ToggleButton"));
var _Canvas = _interopRequireDefault(require("../Canvas"));
var _Description = _interopRequireDefault(require("../Description"));
var _materialStyle = _interopRequireDefault(require("./materialStyle"));
var _context28 = _interopRequireDefault(require("./context"));
var _withDataChange = _interopRequireDefault(require("./withDataChange"));
var _utils = require("./utils");
var style = require("./style_css.js")["default"];
var hideBs = require("./hideBs_css.js")["default"];
function Progress(props) {
  var effect = props.effect,
    style = props.style;
  var _useState = (0, _react.useState)(props.show),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    show = _useState2[0],
    _setShow = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    message = _useState4[0],
    _setMessage = _useState4[1];
  var _setShow2 = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var p,
        _p$value,
        value,
        _args = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _p$value = p.value, value = _p$value === void 0 ? false : _p$value;
            if (!(show !== value)) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return _setShow(value);
          case 5:
            if (!(typeof p.message !== "undefined" && message !== p.message)) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return _setMessage(p.message);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function setShow() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setShow: function () {
            var _setShow3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _setShow2(p);
                  case 2:
                    return _context2.abrupt("return", _context2.sent);
                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            function setShow(_x) {
              return _setShow3.apply(this, arguments);
            }
            return setShow;
          }()
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setShow: function () {
              var _setShow4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function setShow() {
                return _setShow4.apply(this, arguments);
              }
              return setShow;
            }()
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.progress, (0, _defineProperty2["default"])({}, style.show, show))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.progressBrushIcon
  }, /*#__PURE__*/_react["default"].createElement(_Brush["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.progressLinearProgress
  }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], null)), message ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.progressMessage
  }, message) : null);
}
function Controls(props) {
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var externalSettings = externalContext.externalSettings;
  var effect = props.effect,
    style = props.style,
    _props$dotsType = props.dotsType,
    dotsType = _props$dotsType === void 0 ? "number" : _props$dotsType;
  var _useState5 = (0, _react.useState)(props.show || false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    show = _useState6[0],
    _setShow = _useState6[1];
  var _useState7 = (0, _react.useState)(props.playState || 0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    playState = _useState8[0],
    _setPlayState = _useState8[1];
  var _useState9 = (0, _react.useState)(props.timeout || 4000),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    timeout = _useState10[0],
    _setTimeout = _useState10[1];
  var _useState11 = (0, _react.useState)(props.dots || 0),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    dots = _useState12[0],
    _setDots = _useState12[1];
  var _useState13 = (0, _react.useState)(props.currentDot || 0),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    currentDot = _useState14[0],
    _setCurrentDot = _useState14[1];
  var _useState15 = (0, _react.useState)(props.buttons || []),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    buttons = _useState16[0],
    _setButtons = _useState16[1];
  var _useState17 = (0, _react.useState)(props.enablePlayButton || false),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    enablePlayButton = _useState18[0],
    setEnablePlayButton = _useState18[1];
  var _useState19 = (0, _react.useState)({}),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    additionalProps = _useState20[0],
    _setAdditionalProps = _useState20[1];
  var externalControlsMenu = externalSettings.getControlsMenu ? externalSettings.getControlsMenu({
    additionalProps: additionalProps
  }) : [];
  function mergeMenus(a, b) {
    var r = (0, _toConsumableArray2["default"])(a);
    r.forEach(function (m, i) {
      r[i] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, m), m.items ? (0, _toConsumableArray2["default"])(m.items) : []);
    });
    b.forEach(function (m) {
      var foundMenu = r.find(function (rm) {
        return rm.key === m.key;
      });
      if (foundMenu) {
        if (foundMenu.items && m.items) {
          foundMenu.items = [].concat((0, _toConsumableArray2["default"])(foundMenu.items), (0, _toConsumableArray2["default"])(m.items));
          if (foundMenu.items[0] && foundMenu.items[0].divider) {
            foundMenu.items.splice(0, 1);
          }
          Object.keys(m).forEach(function (key) {
            if (key !== "items") {
              foundMenu[key] = m[key];
            }
          });
        }
      } else {
        var addMenu = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, m), m.items ? {
          items: (0, _toConsumableArray2["default"])(m.items)
        } : {});
        if (addMenu.items && addMenu.items[0] && addMenu.items[0].divider) {
          addMenu.items.splice(0, 1);
        }
        r.push(addMenu);
      }
    });
    r.sort(function (a, b) {
      var aO = a.order || 0;
      var bO = b.order || 0;
      return aO > bO ? 1 : aO < bO ? -1 : 0;
    });
    return r;
  }
  var clickActions = (0, _react.useRef)();
  if (!clickActions.current) {
    clickActions.current = {};
  }
  var inactiveTime = (0, _react.useRef)();
  if (!inactiveTime.current) {
    inactiveTime.current = {};
  }
  function clearInactiveTimeout() {
    if (inactiveTime.current.timeout) {
      clearTimeout(inactiveTime.current.timeout);
    }
  }
  function setInactiveTimeout() {
    var _mouseRef$current;
    var newTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : timeout;
    clearInactiveTimeout();
    if (newTimeout > 0 && !((_mouseRef$current = mouseRef.current) !== null && _mouseRef$current !== void 0 && _mouseRef$current.entered)) {
      inactiveTime.current.timeout = setTimeout(function () {
        clearInactiveTimeout();
        _setShow(false);
      }, newTimeout);
    }
  }
  (0, _react.useEffect)(function () {
    if (props.show) {
      setInactiveTimeout();
    }
  }, []);
  var _setState = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
      var p,
        newTimeout,
        _args4 = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            p = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            if (!(typeof p.show === "boolean" && show !== p.show)) {
              _context4.next = 5;
              break;
            }
            clearInactiveTimeout();
            _context4.next = 5;
            return _setShow(p.show);
          case 5:
            if (!(typeof p.show === "boolean" && p.show || typeof p.show === "undefined" && show)) {
              _context4.next = 11;
              break;
            }
            newTimeout = typeof p.timeout === "number" ? p.timeout : props.timeout || 4000;
            setInactiveTimeout(newTimeout);
            if (!(newTimeout !== timeout)) {
              _context4.next = 11;
              break;
            }
            _context4.next = 11;
            return _setTimeout(newTimeout);
          case 11:
            if (!(typeof p.playState === "number")) {
              _context4.next = 15;
              break;
            }
            if (!(p.playState !== playState)) {
              _context4.next = 15;
              break;
            }
            _context4.next = 15;
            return _setPlayState(p.playState);
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function setState() {
      return _ref2.apply(this, arguments);
    };
  }();
  var toggleShow = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _setState({
              show: !show
            });
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function toggleShow() {
      return _ref3.apply(this, arguments);
    };
  }();
  function _setDots3(_x2) {
    return _setDots2.apply(this, arguments);
  }
  function _setDots2() {
    _setDots2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee23(p) {
      var newDots, newCurrentDot;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee23$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            newDots = typeof p.dots !== "undefined" ? p.dots : dots;
            if (!(newDots !== dots)) {
              _context23.next = 4;
              break;
            }
            _context23.next = 4;
            return _setDots(newDots);
          case 4:
            newCurrentDot = typeof p.currentDot !== "undefined" ? p.currentDot : currentDot;
            if (!(newCurrentDot !== currentDot)) {
              _context23.next = 8;
              break;
            }
            _context23.next = 8;
            return _setCurrentDot(newCurrentDot);
          case 8:
          case "end":
            return _context23.stop();
        }
      }, _callee23);
    }));
    return _setDots2.apply(this, arguments);
  }
  function _setButtons3(_x3) {
    return _setButtons2.apply(this, arguments);
  }
  function _setButtons2() {
    _setButtons2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee24(p) {
      var newButtons;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            newButtons = typeof p.buttons !== "undefined" ? JSON.parse(JSON.stringify(p.buttons)) : buttons;
            if (!(JSON.stringify(newButtons) !== JSON.stringify(buttons))) {
              _context24.next = 4;
              break;
            }
            _context24.next = 4;
            return _setButtons(newButtons);
          case 4:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
    return _setButtons2.apply(this, arguments);
  }
  function setClickActions(actions) {
    clickActions.current.actions = actions;
  }
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setEnablePlayButton: setEnablePlayButton,
          setState: function () {
            var _setState2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _setState(p);
                  case 2:
                    return _context6.abrupt("return", _context6.sent);
                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            }));
            function setState(_x4) {
              return _setState2.apply(this, arguments);
            }
            return setState;
          }(),
          setDots: function () {
            var _setDots4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _setDots3(p);
                  case 2:
                    return _context7.abrupt("return", _context7.sent);
                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            function setDots(_x5) {
              return _setDots4.apply(this, arguments);
            }
            return setDots;
          }(),
          setButtons: function () {
            var _setButtons4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return _setButtons3(p);
                  case 2:
                    return _context8.abrupt("return", _context8.sent);
                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }));
            function setButtons(_x6) {
              return _setButtons4.apply(this, arguments);
            }
            return setButtons;
          }(),
          setAdditionalProps: function () {
            var _setAdditionalProps2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return _setAdditionalProps(p);
                  case 2:
                    return _context9.abrupt("return", _context9.sent);
                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9);
            }));
            function setAdditionalProps(_x7) {
              return _setAdditionalProps2.apply(this, arguments);
            }
            return setAdditionalProps;
          }(),
          getShow: function getShow() {
            return show;
          },
          toggleShow: toggleShow,
          setClickActions: setClickActions
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setEnablePlayButton: function () {
              var _setEnablePlayButton = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              function setEnablePlayButton() {
                return _setEnablePlayButton.apply(this, arguments);
              }
              return setEnablePlayButton;
            }(),
            setState: function () {
              var _setState3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }));
              function setState() {
                return _setState3.apply(this, arguments);
              }
              return setState;
            }(),
            setDots: function () {
              var _setDots5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                    case "end":
                      return _context12.stop();
                  }
                }, _callee12);
              }));
              function setDots() {
                return _setDots5.apply(this, arguments);
              }
              return setDots;
            }(),
            setButtons: function () {
              var _setButtons5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              }));
              function setButtons() {
                return _setButtons5.apply(this, arguments);
              }
              return setButtons;
            }(),
            setAdditionalProps: function () {
              var _setAdditionalProps3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              function setAdditionalProps() {
                return _setAdditionalProps3.apply(this, arguments);
              }
              return setAdditionalProps;
            }(),
            toggleShow: function () {
              var _toggleShow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }));
              function toggleShow() {
                return _toggleShow.apply(this, arguments);
              }
              return toggleShow;
            }(),
            getShow: function getShow() {},
            setClickActions: function setClickActions() {}
          }
        });
      }
    };
  });
  var controlsRef = (0, _react.useRef)();
  var mouseRef = (0, _react.useRef)();
  if (!mouseRef.current) {
    mouseRef.current = {};
  }
  (0, _react.useEffect)(function () {
    var mouseEnter = function mouseEnter() {
      mouseRef.current.entered = true;
      clearInactiveTimeout();
    };
    var mouseLeave = function mouseLeave() {
      mouseRef.current.entered = false;
      setInactiveTimeout();
    };
    if (controlsRef.current) {
      controlsRef.current.addEventListener("mouseenter", mouseEnter, false);
      controlsRef.current.addEventListener("mouseleave", mouseLeave, false);
    }
    return function () {
      if (controlsRef.current) {
        controlsRef.current.removeEventListener("mouseenter", mouseEnter);
        controlsRef.current.removeEventListener("mouseleave", mouseLeave);
      }
    };
  });
  var Icons = {
    splitScreen: _Window["default"],
    calloutNotations: _DesignServices["default"],
    editLines: _Architecture["default"],
    save: _Save["default"],
    fullPage: _Fullscreen["default"],
    camera: _Videocam["default"],
    ar: _ViewInAr["default"]
  };
  var _onClick2 = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(e, key) {
      var newButtons, button;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            newButtons = JSON.parse(JSON.stringify(buttons));
            button = newButtons.find(function (b) {
              return b.key === key;
            });
            button.value = !button.value;
            if (button.oneStateButton) {
              button.value = false;
            }
            _context16.next = 6;
            return _setButtons3({
              buttons: newButtons
            });
          case 6:
            if (clickActions.current.actions && clickActions.current.actions[button.key]) {
              clickActions.current.actions[button.key]({
                e: e,
                value: button.value
              });
            }
          case 7:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return function onClick(_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
  var mergedButtons = mergeMenus(buttons, externalControlsMenu);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.controls, (0, _defineProperty2["default"])({}, style.fixedControls, externalSettings.fixedControls)),
    ref: controlsRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.controlsInner, (0, _defineProperty2["default"])({}, style.show, show), (0, _defineProperty2["default"])({}, style.empty, !(dots > 1 || mergedButtons.length || enablePlayButton)))
  }, dots > 1 && dotsType !== "number" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.dots
  }, (0, _toConsumableArray2["default"])(Array(dots).fill()).map(function (u, i) {
    var _clickActions$current2;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      onClick: /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17(e) {
          var _clickActions$current;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                if (!((_clickActions$current = clickActions.current.actions) !== null && _clickActions$current !== void 0 && _clickActions$current.onDotClick)) {
                  _context17.next = 5;
                  break;
                }
                if (!(playState === 0 || playState === 2)) {
                  _context17.next = 5;
                  break;
                }
                e.preventDefault();
                _context17.next = 5;
                return clickActions.current.actions.onDotClick({
                  compositionIndex: i
                });
              case 5:
              case "end":
                return _context17.stop();
            }
          }, _callee17);
        }));
        return function (_x10) {
          return _ref5.apply(this, arguments);
        };
      }(),
      className: (0, _clsx17["default"])(style.dot, (0, _defineProperty2["default"])({}, style.isCurrentDot, currentDot === i), (0, _defineProperty2["default"])({}, style.cursorPointer, (_clickActions$current2 = clickActions.current.actions) === null || _clickActions$current2 === void 0 ? void 0 : _clickActions$current2.onDotClick), (0, _defineProperty2["default"])({}, style.disable, playState === 1))
    });
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.leftButtons, (0, _defineProperty2["default"])({}, style.empty, !mergedButtons.length), (0, _defineProperty2["default"])({}, style.disable, playState === 1 || playState === 2))
  }, mergedButtons.length ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _toConsumableArray2["default"])(mergedButtons.map(function (button, i) {
    var Icon = Icons[button.key];
    var menuRef = {
      current: {
        actions: {}
      }
    };
    if (button.items) {
      return /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        key: i,
        effect: function effect(_ref6) {
          var actions = _ref6.actions;
          return menuRef.current.actions = actions;
        },
        menu: button.items.map(function (menu) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, menu), {}, {
            onClick: function () {
              var _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18(e) {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
                  while (1) switch (_context18.prev = _context18.next) {
                    case 0:
                      if (!menu.onClick) {
                        _context18.next = 4;
                        break;
                      }
                      _context18.next = 3;
                      return menu.onClick(e);
                    case 3:
                      return _context18.abrupt("return", _context18.sent);
                    case 4:
                      if (clickActions.current.actions && clickActions.current.actions[button.key]) {
                        clickActions.current.actions[button.key]({
                          e: e,
                          value: menu.key
                        });
                      }
                    case 5:
                    case "end":
                      return _context18.stop();
                  }
                }, _callee18);
              }));
              function onClick(_x11) {
                return _onClick.apply(this, arguments);
              }
              return onClick;
            }()
          });
        }),
        onClickBefore: /*#__PURE__*/function () {
          var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee19(e) {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee19$(_context19) {
              while (1) switch (_context19.prev = _context19.next) {
                case 0:
                  if (clickActions.current.actions && clickActions.current.actions[button.key]) {
                    clickActions.current.actions[button.key]({
                      e: e,
                      value: "open"
                    });
                  }
                case 1:
                case "end":
                  return _context19.stop();
              }
            }, _callee19);
          }));
          return function (_x12) {
            return _ref7.apply(this, arguments);
          };
        }(),
        MoreIcon: Icon ? Icon : undefined,
        menuKey: button.key + "Menu",
        menuComponentProps: {
          container: controlsRef.current
        },
        disabled: playState === 1 || playState === 2 || button.disabled
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_ToggleButton["default"], {
      size: "small",
      key: i,
      value: button.key,
      selected: !!mergedButtons.find(function (b) {
        return b.key === button.key;
      }).value,
      disabled: playState === 1 || playState === 2 || button.disabled,
      onClick: function onClick(e) {
        return button.onClick ? button.onClick(e) : _onClick2(e, button.key);
      }
    }, Icon ? /*#__PURE__*/_react["default"].createElement(Icon, null) : null);
  }))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.rightColumn, (0, _defineProperty2["default"])({}, style.empty, !(dots > 1 || enablePlayButton)))
  }, dots > 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.prevButton, (0, _defineProperty2["default"])({}, style.disable, playState === 1))
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disabled: playState === 1,
    onClick: /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee20(e) {
        var _clickActions$current3;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!((_clickActions$current3 = clickActions.current.actions) !== null && _clickActions$current3 !== void 0 && _clickActions$current3.onDotClick)) {
                _context20.next = 5;
                break;
              }
              if (!(playState === 0 || playState === 2)) {
                _context20.next = 5;
                break;
              }
              e.preventDefault();
              _context20.next = 5;
              return clickActions.current.actions.onDotClick({
                compositionIndex: currentDot - 1
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x13) {
        return _ref8.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/_react["default"].createElement(_SkipPrevious["default"], null))), dotsType === "number" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.dotsNumber, (0, _defineProperty2["default"])({}, style.disable, playState === 1))
  }, /*#__PURE__*/_react["default"].createElement("span", null, currentDot + 1), /*#__PURE__*/_react["default"].createElement("span", null, "/"), /*#__PURE__*/_react["default"].createElement("span", null, dots)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.nextButton, (0, _defineProperty2["default"])({}, style.disable, playState === 1))
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disabled: playState === 1,
    onClick: /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee21(e) {
        var _clickActions$current4;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!((_clickActions$current4 = clickActions.current.actions) !== null && _clickActions$current4 !== void 0 && _clickActions$current4.onDotClick)) {
                _context21.next = 5;
                break;
              }
              if (!(playState === 0 || playState === 2)) {
                _context21.next = 5;
                break;
              }
              e.preventDefault();
              _context21.next = 5;
              return clickActions.current.actions.onDotClick({
                compositionIndex: currentDot + 1
              });
            case 5:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function (_x14) {
        return _ref9.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/_react["default"].createElement(_SkipNext["default"], null)))) : null, enablePlayButton ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.playButton, (0, _defineProperty2["default"])({}, style.pulse, playState === 1), (0, _defineProperty2["default"])({}, style.disable, playState === 1))
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disabled: playState === 1,
    onClick: /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee22(e) {
        var _clickActions$current5;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!((_clickActions$current5 = clickActions.current.actions) !== null && _clickActions$current5 !== void 0 && _clickActions$current5.onPlayClick)) {
                _context22.next = 5;
                break;
              }
              if (!(playState === 0 || playState === 2)) {
                _context22.next = 5;
                break;
              }
              e.preventDefault();
              _context22.next = 5;
              return clickActions.current.actions.onPlayClick({
                playState: playState === 2 ? 0 : 2
              });
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function (_x15) {
        return _ref10.apply(this, arguments);
      };
    }()
  }, playState === 0 ? /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], null) : /*#__PURE__*/_react["default"].createElement(_Pause["default"], null))) : null))));
}
function Snackbar(props) {
  var _useState21 = (0, _react.useState)(""),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    message = _useState22[0],
    setMessage = _useState22[1];
  var handleClose = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee25() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee25$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return setMessage("");
          case 2:
          case "end":
            return _context25.stop();
        }
      }, _callee25);
    }));
    return function handleClose() {
      return _ref11.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (props.effect) {
      props.effect({
        actions: {
          setMessage: setMessage
        }
      });
    }
    return function () {
      if (props.effect) {
        props.effect({
          actions: {
            setMessage: function setMessage() {}
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    open: !!message,
    autoHideDuration: 6000,
    onClose: handleClose,
    message: message
  });
}
function Artwork(props) {
  var _data$settings, _data$settings$basic_, _clsx16;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var postContext = (0, _react.useContext)(_context26["default"]);
  var appContext = (0, _react.useContext)(_context27["default"]);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var externalSettings = externalContext.externalSettings;
  var wapp = context.wapp,
    res = context.res,
    req = context.req;
  var routes = appContext.routes,
    messages = appContext.messages;
  var fullPage = props.fullPage,
    effect = props.effect,
    _props$Canvas = props.Canvas,
    Canvas = _props$Canvas === void 0 ? _Canvas["default"] : _props$Canvas,
    useDataChange = props.useDataChange;
  var artworkContext = (0, _utils.createArtworkContext)({
    context: context,
    appContext: appContext,
    postContext: postContext,
    externalContext: externalContext
  });
  var data = artworkContext.data;
  var configuration = artworkContext.configuration;
  var translate = artworkContext.translate;
  var isAuthorOrAdmin = (0, _utils.getIsAuthorOrAdmin)({
    appContext: appContext,
    postContext: postContext
  });
  if (isAuthorOrAdmin && wapp.target === "web") {
    console.log("[APP] Initialized data and configuration ", data, configuration);
  }
  var requestPath = res.wappResponse.route.requestPath;
  var description = translate(data === null || data === void 0 ? void 0 : (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.description) || "";
  var defaultDescription = translate(messages.defaultDescription);
  var isThereDesc = description || defaultDescription;
  var fullPageArtwork = requestPath.startsWith(routes.artworkRoute) || requestPath.startsWith(routes.renderRoute) || requestPath.startsWith(routes.editorRoute) || !isThereDesc;
  var summaryType = !fullPageArtwork && requestPath === "/" && isThereDesc || res.wappResponse.route.path === "/:page" && res.wappResponse.route.params.page === "splitscreen" || requestPath.startsWith(routes.summaryRoute);
  wapp.styles.use(style);
  if (requestPath.startsWith(routes.renderRoute)) {
    wapp.styles.use(hideBs);
  }
  useDataChange(function (payload) {
    if (externalSettings.onDataChange) {
      externalSettings.onDataChange(payload.value);
    }
  });
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setData: function setData() {
            artworkContext.setData.apply(artworkContext, arguments);
          }
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setData: function setData() {}
          }
        });
      }
    };
  });
  var query = req.wappRequest.query;
  var progressRef = (0, _react.useRef)();
  var controlsRef = (0, _react.useRef)();
  var snackRef = (0, _react.useRef)();
  var disableFirstAnimationFromExternal = query.disableFirstAnimation || externalSettings.disableFirstAnimation;
  var defaultCanvasProps = {
    disableFirstAnimation: requestPath.startsWith(routes.renderRoute) && !query.enableFirstAnimation && !externalSettings.enableFirstAnimation || requestPath.startsWith(routes.artworkRoute) && !query.enableFirstAnimation && !externalSettings.enableFirstAnimation || requestPath === "/" && !query.enableFirstAnimation && !externalSettings.enableFirstAnimation || query.disableFirstAnimation || externalSettings.disableFirstAnimation ? true : undefined,
    disableFirstRunAnimation: requestPath.startsWith(routes.renderRoute) && !query.enableFirstRunAnimation && !externalSettings.enableFirstRunAnimation || query.disableFirstRunAnimation || externalSettings.disableFirstRunAnimation ? true : undefined,
    disableAutoStartAnimationInactivity: requestPath.startsWith(routes.renderRoute) && !query.enableAutoStartAnimationInactivity && !externalSettings.enableAutoStartAnimationInactivity || query.disableAutoStartAnimationInactivity || externalSettings.disableAutoStartAnimationInactivity ? true : undefined,
    enableAnimation: !(query.disableAnimation || externalSettings.disableAnimation),
    enableAnimationKeys: !disableFirstAnimationFromExternal && (requestPath.startsWith(routes.renderRoute) || requestPath.startsWith(routes.artworkRoute) || requestPath === "/") ? ["enableFirstAnimation"] : undefined,
    splitScreen: res.wappResponse.route.params.page === "splitscreen",
    index: typeof query.index === "string" && Number(query.index) >= 0 ? Number(query.index) : 0,
    onComplete: function onComplete() {
      if (externalSettings.onComplete) {
        externalSettings.onComplete.apply(externalSettings, arguments);
      }
    },
    editor: requestPath.startsWith(routes.editorRoute),
    progressRef: progressRef,
    controlsRef: controlsRef,
    snackRef: snackRef,
    className: style.canvas
  };
  return /*#__PURE__*/_react["default"].createElement(_context28["default"].Provider, {
    value: artworkContext
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx17["default"])(style.artwork, (_clsx16 = {}, (0, _defineProperty2["default"])(_clsx16, style.render, requestPath.startsWith(routes.renderRoute)), (0, _defineProperty2["default"])(_clsx16, style.fullPageArtwork, fullPageArtwork), (0, _defineProperty2["default"])(_clsx16, style.summaryType, summaryType), (0, _defineProperty2["default"])(_clsx16, style.editor, requestPath.startsWith(routes.editorRoute)), (0, _defineProperty2["default"])(_clsx16, style.fixedControls, externalSettings.fixedControls), _clsx16))
  }, requestPath === routes.descriptionRoute ? /*#__PURE__*/_react["default"].createElement(_Description["default"], null) : fullPageArtwork ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Progress, {
    style: style,
    effect: function effect(current) {
      progressRef.current = current;
    },
    show: true
  }), /*#__PURE__*/_react["default"].createElement(Controls, {
    style: style,
    effect: function effect(current) {
      controlsRef.current = current;
    }
  }), /*#__PURE__*/_react["default"].createElement(Canvas, Object.assign({
    fullPage: fullPage
  }, defaultCanvasProps))) : summaryType ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.summary
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.artworkContainer
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Progress, {
    style: style,
    effect: function effect(current) {
      progressRef.current = current;
    },
    show: true
  }), /*#__PURE__*/_react["default"].createElement(Controls, {
    style: style,
    effect: function effect(current) {
      controlsRef.current = current;
    }
  }), /*#__PURE__*/_react["default"].createElement(Canvas, defaultCanvasProps))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.descriptionContainer
  }, /*#__PURE__*/_react["default"].createElement(_Description["default"], null))) : null), /*#__PURE__*/_react["default"].createElement(Snackbar, {
    effect: function effect(current) {
      return snackRef.current = current;
    }
  }));
}
var _default = (0, _withDataChange["default"])((0, _withMaterial.withMaterialStyles)(_materialStyle["default"], Artwork));
exports["default"] = _default;